<template>
  <div>
    <h4>Locks for {{ props.userName }}</h4>
    <div class="table-detail" v-for="lock in locks" :key="lock.id">
      <div class="checkbox-label">
        <label :for="'range_' + lock.id">Interval: </label>
        <VueDatePicker v-model="lock.range" range :enable-time-picker="false" :teleport="true" :clearable="false"
          :id="'range_' + lock.id" utc="preserve" class="rangeRM stool" :format="formatMXDateRange"></VueDatePicker>
        <label :for="'lock_' + lock.id">Is locked: </label>
        <input :id="'lock_' + lock.id" type="checkbox" :checked="getIsLockChecked(lock)" @change="onLockedChanged(lock, $event)" class="stool" />
      </div>
    </div>
    <div class="buttons">
      <button @click="addInterval()">+ Add interval</button>
      <button class="accent" @click="save">Save</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LockHistoryItem } from "@/services/entities/LockHistoryItem";
import { useReportingMonthStore } from "@/stores/reporting";
import { useLockItemsStore } from "@/stores/lock";
import { Authorization } from "@/services/authenticate";
import { formatMXDateRange } from "@/common/date";
import { showToastError } from "@/toastification";


const lockStore = useLockItemsStore();
const reportingStore = useReportingMonthStore();
const emit = defineEmits(["delete", "change", "close", "refreshUsers"]);

const props = defineProps({
  locks: { Type: [] as LockHistoryItem[], default: [] as LockHistoryItem[] },
  userName: { Type: {} as string, default: "Unknown" as string },
  userId: { Type: {} as string, default: "" as string },
  year: { Type: {} as number },
  month: { Type: {} as number },
});

function onLockedChanged(lock: LockHistoryItem, event: Event) {
  let isLocked = (event.target as HTMLInputElement).checked;
  lock.isLocked = isLocked;
}

function getIsLockChecked(lock: LockHistoryItem): boolean {
  return lock.isLocked;
}

function addInterval() {
  let newInterval = {
    dateFrom: new Date(),
    dateTo: new Date(),
    isLocked: false,
    isPlaceholder: false,
    lockedUserId: props.userId,
  } as LockHistoryItem;
  props.locks.push(newInterval);
}

async function save() {
  let hasError = false;
  props.locks.forEach((a: LockHistoryItem) => {
      a.dateFrom = new Date(a.range.length >=1 ? a.range[0] : a.dateFrom);
      a.dateTo = new Date(a.range.length >= 2 ? a.range[1] : a.dateTo);
      a.range = [a.dateFrom, a.dateTo];
      if (a.dateFrom.getMonth() != a.dateTo.getMonth()) {
        showToastError("Date range cannot span multiple months");
        hasError = true;
      }
  });  
  if (hasError) {
    return;
  }
  await lockStore.saveLockItems(props.locks, props.userId, Authorization.id);
  emit('refreshUsers');
  await reportingStore.loadReportingMonth(
    props.year,
    props.month,
    props.userId
  );
}
</script>

<style>
.checkbox-label {
  display: flex;
  align-items: center;
}

.checkbox-label input {
  margin-right: 5px;
}

.rangeRM {
  margin-right: 55px;
}

.stool {
  margin-bottom: 7px;
}
</style>